import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  makeStyles,
  Select,
  MenuItem,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  withStyles,
  TablePagination,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  IconButton,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { withRouter } from "react-router-dom";
import {
  getDegree,
  getDegreeCourse,
  clearData,
  clearErrorMessage,
  clearErrorStatusCode,
} from "../../../reduxSlices/degreeSlice";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop/";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import localizedStrings from "../../../utils/localize";
import {
  getApplicantStatus,
  getOptionList,
} from "../../../reduxSlices/applicationSlice";
import '../DegreePlan/ckeditor-content.css';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 168,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  "MuiAppBar-root": {
    zIndex: "98",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DegreePlan = (props) => {
  const dispatch = useDispatch();
  const [degree, setDegree] = useState([]);
  const [studentId, setStudentId] = useState(undefined);
  const [tableMapData, setTableMapData] = useState([]);
  const [groupCourses, setGroupCourses] = useState([]);
  const [programDescription, setProgramDescription] = useState([]);
  const [value, setValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const classes = useStyles();
  const [selectedDegree, setSelectedDegree] = useState("");
  const [certificationProgramid, setCertificationProgramid] = useState(null);
  
  const [defaultSelectedDegreeId, setDefaultSelectedDegreeId] = useState("");
  const [displayMessage, setDisplayMessage] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [expanded, setExpanded] = useState({});
  const degreeData = useSelector((state) => state.degreeData.degree);
  const studentcanviewegreeplan = useSelector(
    (state) => state.degreeData.studentcanviewegreeplan,
  );
  const degreeCoursesData = useSelector(
    (state) => state.degreeData.degreeCourses,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const errorMessage = useSelector((state) => state.degreeData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.degreeData.errorStatusCode,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.degreeData.dataFetchingStatus,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);

  useEffect(() => {
    const entity = "ses_studentrequiredcourse";
    const attributename = "ses_studentsessionstatus";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  const funcOptionList = (status) => {
    let value;
    if (optionList?.length !== 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
        return null;
      });
    }
    return value;
  };

  useEffect(() => {
    if (degreeCoursesData?.requiredCourses?.length === 0) {
      setTableMapData([]);
      setValue(1);
    }
    if (degreeCoursesData?.groupCourses?.length === 0) {
      setGroupCourses([]);
      setValue(0);
    }
    if (
      degreeCoursesData.requiredCourses &&
      degreeCoursesData.requiredCourses.length
    ) {
      let degreeCourses = [...degreeCoursesData?.requiredCourses];
      setTableMapData(
        degreeCourses.sort(
          (a, b) => parseFloat(a.ses_order) - parseFloat(b.ses_order),
        ),
      );
    }
    if (
      degreeCoursesData.groupCourses &&
      degreeCoursesData.groupCourses.length > 0
    ) {
      let groupCourses = degreeCoursesData.groupCourses;
    
      // Filter out empty course objects
      groupCourses = groupCourses.map((courseGroup) => ({
        ...courseGroup,
        data: courseGroup?.data?.filter(
          (course) => Object.keys(course).length > 0
        ),
      }));
    
      // Sort by ses_order (as number) in ascending order
      groupCourses.sort((a, b) => {
        const orderA = parseInt(a?.ses_order || '0', 10);
        const orderB = parseInt(b?.ses_order || '0', 10);
        return orderA - orderB;
      });
    
      setGroupCourses(groupCourses);
    }
    if (degreeCoursesData?.programDescription?.length > 0) {
      setProgramDescription(degreeCoursesData.programDescription);
    }
  }, [degreeCoursesData, selectedDegree]);

  useEffect(() => {
    if (degreeData && degreeData?.length > 0) {
      const sortDegree = degreeData
        ?.slice()
        .sort((a, b) =>
          a.ses_certificationprogramname.localeCompare(
            b.ses_certificationprogramname,
          ),
        );
      setDegree(sortDegree);

      const programId = sortDegree.filter(
        (v) =>
          v.ses_degreeplanid ===
          studentcanviewegreeplan[0]?._usb_primarydegreeplan_value,
      );

      if (studentcanviewegreeplan.length > 0) {
        setSelectedDegree(
          studentcanviewegreeplan[0]?._usb_primarydegreeplan_value,
        );
        setDefaultSelectedDegreeId(
          studentcanviewegreeplan[0]?._usb_primarydegreeplan_value,
        );
        setCertificationProgramid(programId[0]._ses_certificationprogramid_value)
      }
    }
  }, [degreeData, studentcanviewegreeplan]);

  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
      dispatch(getDegree(applicantStatus.ses_applicantstatus.ses_studentid));
    }
  }, [applicantStatus]);

  useEffect(() => {
    if (selectedDegree && studentId) {
      dispatch(getDegreeCourse({ degreeId: selectedDegree, studentId,certificationProgramid }));
    }
  }, [selectedDegree]);
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);
  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };
  useEffect(() => {
    return () => {
      dispatch(clearData());
    };
  }, []);
  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tableData = "";
  if (tableMapData.length > 0) {
    tableData = tableMapData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((degreeCourse) => {
        return (
          <StyledTableRow>
            <StyledTableCell align="left">
              {degreeCourse.ses_course}
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse.ses_coursename}
            </StyledTableCell>
            <StyledTableCell align="left">
              {funcOptionList(degreeCourse.ses_studentsessionstatus)}
            </StyledTableCell>
            <StyledTableCell align="left">
              {
                degreeCourse[
                  "ses_creditsavailable@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </StyledTableCell>
            <StyledTableCell align="left">
              {
                degreeCourse[
                  "ses_credittype@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </StyledTableCell>
            <StyledTableCell align="left">
              {
                degreeCourse[
                  "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse["ses_gradereceived"]}
            </StyledTableCell>
          </StyledTableRow>
        );
      });
  }

  useEffect(() => {
    if (error.message === "student id is required") {
      setDisplayMessage(localizedStrings.general.studentiderrorMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };
  const handleChangeDegreePlan = (event) => {
    setSelectedDegree(event.target.value);
  };

  const toggleExpand = (courseGroupName) => {
    setExpanded((prev) => ({
      ...prev,
      [courseGroupName]: !prev[courseGroupName],
    }));
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />

      {studentcanviewegreeplan?.length > 0 &&
        !studentcanviewegreeplan[0]?.usb_canviewdegreeplan && (
          <div
            style={{
              margin: "2rem 0 23rem 0",
              fontSize: "16px",
            }}
          >
            {localizedStrings.students.degreePlan.canviewegreeplan}
          </div>
        )}

      {studentcanviewegreeplan?.length > 0 &&
        studentcanviewegreeplan[0]?.usb_canviewdegreeplan && (
          <>
            <FormControl className={classes.formControl}>
              <InputLabel id="degree-plan">
                {localizedStrings.students.degreePlan.degreePlan}
              </InputLabel>
              <Select
                labelId="degree-plan"
                id="degree-plan"
                value={selectedDegree}
                defaultValue={defaultSelectedDegreeId}
                disabled={degree.length === 0}
                onChange={handleChangeDegreePlan}
              >
                <MenuItem value="" style={{ display: "none" }}></MenuItem>

                {degree.map((data) => (
                  <MenuItem
                    key={data.ses_degreeplanid}
                    value={data.ses_degreeplanid}
                  >
                    {data.ses_certificationprogramname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <AppBar
              position="static"
              classes={{ root: classes["MuiAppBar-root"] }}
            >
              <Tabs value={value} onChange={handleChange} aria-label="courses">
                <Tab
                  label={
                    localizedStrings.students.degreePlan.requireddegreecourses
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    localizedStrings.students.degreePlan.degreecoursegroups
                  }
                  disabled={!selectedDegree || dataFetchingStatus}
                  {...a11yProps(1)}
                />
                <Tab
                  label={
                    localizedStrings.students.degreePlan.programDescription
                  }
                  disabled={!selectedDegree || dataFetchingStatus}
                  {...a11yProps(2)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <TableContainer
                component={Paper}
                style={{ minHeight: "46.5vh", marginBottom: "10px" }}
              >
                <Table aria-label="required degree course">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.course}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.coursename}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.status}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.creditsavailable}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.creditstype}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.creditsearned}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {localizedStrings.students.degreePlan.grade}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>{tableData}</TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  component="div"
                  count={tableMapData.length > 0 ? tableMapData.length : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  labelRowsPerPage={
                    <span style={{ textTransform: "none" }}>
                      {localizedStrings.rows.rowsperpage}
                    </span>
                  }
                  labelDisplayedRows={customLabelDisplayedRows}
                />
              </TableContainer>
            </TabPanel>
            <TabPanel value={value} index={1}>
              {groupCourses.map((courses) => {
                const isExpanded =
                  expanded[courses.ses_coursegroupname] || false;
                return (
                  <div key={courses.ses_coursegroupname}>
                    <Typography
                      component="h6"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <IconButton
                        onClick={() =>
                          toggleExpand(courses.ses_coursegroupname)
                        }
                      >
                        {isExpanded ? (
                          <RemoveIcon fontSize="large" />
                        ) : (
                          <AddIcon fontSize="large" />
                        )}
                      </IconButton>

                      <span style={{ fontWeight: "bold" }}>
                        {courses.ses_coursegroupname}
                      </span>
                    </Typography>
                    <Typography style={{ marginLeft: "3.7rem" }}>
                      <span style={{ fontWeight: "bold" }}>
                        {courses.ses_coursegroupdescription}
                      </span>
                    </Typography>
                    <Typography style={{ marginLeft: "3.7rem" }}>
                      <span style={{ fontWeight: "bold" }}>
                        {localizedStrings.students.degreePlan.creditsrequired}
                      </span>{" "}
                      :{" "}
                      {
                        courses[
                          "ses_creditsrequired@OData.Community.Display.V1.FormattedValue"
                        ]
                      } 
                    </Typography>
                    {isExpanded && (
                      <>
                        <TableContainer
                          component={Paper}
                          style={{ minHeight: "46.5vh", marginBottom: "10px" }}
                        >
                          <Table aria-label="required degree course">
                            <TableHead>
                              <StyledTableRow>
                                <StyledTableCell align="left">
                                  {localizedStrings.students.degreePlan.course}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  {
                                    localizedStrings.students.degreePlan
                                      .coursename
                                  }
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  {localizedStrings.students.degreePlan.status}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  {
                                    localizedStrings.students.degreePlan
                                      .creditsavailable
                                  }
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  {
                                    localizedStrings.students.degreePlan
                                      .creditstype
                                  }
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  {
                                    localizedStrings.students.degreePlan
                                      .creditsearned
                                  }
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                  {localizedStrings.students.degreePlan.grade}
                                </StyledTableCell>
                              </StyledTableRow>
                            </TableHead>
                            {courses.data.length === 0 && (
                              <TableBody>
                                <div>No data available </div>
                              </TableBody>
                            )}
                            <TableBody>
                              {courses?.data
                                ?.sort((a, b) =>
                                  a.ses_course.localeCompare(b.ses_course),
                                )
                                .map((degreeCourse) => {
                                  return (
                                    <StyledTableRow>
                                      <StyledTableCell align="left">
                                        {degreeCourse.ses_course}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {degreeCourse.ses_coursename}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {funcOptionList(
                                          degreeCourse.ses_studentsessionstatus,
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {
                                          degreeCourse[
                                            "ses_credits@OData.Community.Display.V1.FormattedValue"
                                          ]
                                        }
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {
                                          degreeCourse[
                                            "ses_credittype@OData.Community.Display.V1.FormattedValue"
                                          ]
                                        }
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {
                                          degreeCourse[
                                            "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                                          ]
                                        }
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {degreeCourse["ses_gradereceived"]}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    )}
                  </div>
                );
              })}
            </TabPanel>
            <TabPanel value={value} index={2}>
              {programDescription.length > 0 && (
                <>
                  <div
                  className="ck-content"
                    dangerouslySetInnerHTML={{
                      __html: programDescription[0].ses_programdescription,
                    }}
                  />
                </>
              )}
            </TabPanel>
          </>
        )}
    </Aux>
  );
};

export default withRouter(DegreePlan);
